import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import { startLiveCasinoSessionReq } from 'stores/auth/services';
// import { getDeviceType, getLanguageCode } from 'toolkit/utils';

function BlackBox(props) {
  const { to, icon, iconType, text1, text2 } = props;
  const { t } = useTranslation('translations', { useSuspense: false });
  // const user = useSelector((state) => state.auth.user);
  // const openCasionFrame = to === '/casino' && getDeviceType() === 'iphone';
  return (
    <div className="card p-1 h-full bg-primary">
      <Link
        className="d-flex flex-column text-white"
        to={to}
        // onClick={(e) => {
        //   if (openCasionFrame) {
        //     e.stopPropagation();
        //     StartSession(user);
        //   }
        // }}
      >
        <div className="text-end">
          {iconType === 'flag' ? (
            <img width="20" height="13" src={icon} alt={text1 || text2}></img>
          ) : (
            <img
              className="icon-color"
              width="22"
              height="22"
              src={icon}
              alt={text1 || text2}></img>
          )}
        </div>
        <div className={`text-start mt-n1 fs-8 line-clamp-2`}>
          {t(text1) || <span>&nbsp;</span>}
        </div>
      </Link>
    </div>
  );
}

export default BlackBox;
